import api from '../client'
import { toJobOption } from '../../features/project-management/common/pmOptionUtils'

export async function fetchJobOptions(search = '', page = 1, pageSize = 20, projectId = null) {
  const params = {
    search,
    page,
    page_size: pageSize,
    archive: false,
    fromDate: '1900-01-01',
    toDate: '9999-12-31',
  }
  if (projectId && projectId !== 'All' && projectId !== 'all') {
    params.project_id = Number(projectId)
  }
  const { data } = await api.get('/jobs/', { params })
  const rawItems = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : []
  const items = rawItems.map(toJobOption).filter(Boolean)
  const hasMore = rawItems.length === pageSize
  return { items, hasMore }
}

